import React from 'react';
import { Flex, Box, Heading, Text, ListItem, UnorderedList, Center, Image } from '@chakra-ui/react';
import SectionImage from '../../assets/Landing/DownloadIllustration.svg';

function DownloadSection() {
  return (
    <Flex
      minHeight="70vh"
      alignItems="center"
      justifyContent="center"
      p={10}
      pt="50px"
      pb="50px"
      direction={{ base: 'column-reverse', md: 'row' }}  // Intercambia el orden en dispositivos móviles y pantallas medianas hacia arriba
      id="Download"
    >
      <Flex
        w="full"
      
        mx="auto"
        justify="space-between"
        direction={{ base: 'column-reverse', md: 'row' }}  // Intercambia el orden igual que el contenedor principal
      >
        {/* Left Container, ahora en la parte superior en dispositivos móviles */}
        <Flex
          w={{ base: '100%', md: '50%' }}  // Ajusta el ancho según el tamaño de pantalla
          direction="column"
          justifyContent="center"
          alignItems={{ base: 'center', md: 'flex-start' }}  // Centrado en móviles, alineado a la izquierda en escritorio
          px={5}
          order={{ base: 1, md: 2 }}  // Aparece primero en móvil y segundo en escritorio
        >
          <Heading as="h3" size="xl" color="var(--600, #0D1216)" fontFamily="Quicksand" fontWeight="700" lineHeight="48px">
            How does TEA work?
          </Heading>
          <Text my={5} color="var(--500, #313C45)" fontFamily="Quicksand" fontWeight="500" lineHeight="32px">
            Discover the magic of EduPlay in just a few simple steps! Download the app and unlock a world where learning meets
            play. All designed to captivate young minds and make education an exciting journey.
          </Text>
          <UnorderedList listStyleType="none" spacing={10} m={0}>
            {["Download our app", "Explore and Sign Up", "Customize preferences for a personalized learning", "Dive into TEA", "Track Progress and Celebrate Achievements", "Stay Connected & Enjoy the Benefits of TEA"].map(
              (step, index) => (
                <ListItem key={index} color="var(--600, #0D1216)" fontFamily="Quicksand" fontWeight="600" lineHeight="32px">
                  <Flex align="center">
                    <Center w="43px" h="43px" bg="#90BCB5" borderRadius="full" color="white" mr={4}>
                      <Text fontSize="22px" lineHeight="28px">
                        {index + 1}
                      </Text>
                    </Center>
                    {step}
                  </Flex>
                </ListItem>
              )
            )}
          </UnorderedList>
        </Flex>
        {/* Right Container, ahora en la parte inferior en dispositivos móviles */}
        <Center
          w={{ base: '100%', md: '50%' }}  // Ajusta el ancho según el tamaño de pantalla
          px={{ base: 5, md: 0 }}  // Añade espaciado horizontal en móviles y quita en escritorio
          mb={{ base: 5, md: 0 }}  // Margen inferior solo en móviles
          order={{ base: 2, md: 1 }}  // Aparece segundo en móvil y primero en escritorio
        >
          <Flex align="center" justify="center" w="100%"> {/* Nuevo Flex para centrar la imagen */}
            <Box>
              <Image src={SectionImage} alt="Section Illustration" maxW="80%" mx="auto" /> {/* Ancho de la imagen ajustado */}
            </Box>
          </Flex>
        </Center>
      </Flex>
    </Flex>
  );
}

export default DownloadSection;
